interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionHeading({ eyebrow, title, desc, align = "center" }: SectionHeadingProps) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col gap-3 mb-8 md:mb-12 ${alignCls}`}>
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-bold tracking-wide uppercase">
        <i className="ri-sparkling-2-fill text-accent-500"></i>
        {eyebrow}
      </span>
      <h2 className="text-2xl md:text-4xl font-black text-foreground-950 leading-tight">{title}</h2>
      {desc ? <p className="text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">{desc}</p> : null}
    </div>
  );
}